import { useMutation } from '@apollo/client'

import { appliedFiltersToGraphQLVariables } from 'utils/filters/utils'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

import { UPDATE_SELECTED_ORDERS } from './ChangeSalesRepModal.component'
import { orderFilters } from 'containers/OrderListFilters/filters'

const bulkUpdateOrderSalesRep = atlas`#graphql
  mutation BulkUpdateOrderSalesRepByFilters(
    $input: BulkUpdateOrderSalesRepByFiltersInput!
  ) {
    bulkUpdateOrderSalesRepByFilters(input: $input) {
      updatedOrdersCount
    }
  }
`

export const useBulkUpdateOrderSalesRep = (
  orderIds,
  appliedFilters,
  searchFilter,
) => {
  const [bulkUpdateOrderSalesRepAction] = useMutation(bulkUpdateOrderSalesRep, {
    client: atlasClient,
  })
  const onBulkUpdateOrderSalesRepAction = async (updateMode, newSalesRep) => {
    let variables = {}
    if (updateMode === UPDATE_SELECTED_ORDERS) {
      variables = {
        input: {
          appliedFilters: {
            ids: orderIds,
          },
          newSalesRep,
        },
      }
    } else {
      variables = {
        input: {
          appliedFilters: {
            ...appliedFiltersToGraphQLVariables(orderFilters, appliedFilters),
            ids: [],
          },
          searchFilter,
          newSalesRep,
        },
      }
    }

    return await bulkUpdateOrderSalesRepAction({ variables })
  }
  return onBulkUpdateOrderSalesRepAction
}

export const withUpdateOrderSalesRepMutation =
  (WrappedComponent) => (props) => {
    const customProps = {
      ...props,
      handleUpdateOrderSalesRep: useBulkUpdateOrderSalesRep(
        props.selectedOrderIds || props.orderIds,
        props.appliedFilters,
        props.searchFilter,
      ),
    }

    return <WrappedComponent {...customProps} />
  }
